import { observer } from 'mobx-react'
import styles from './DiscountCodeInput.module.less'
import { Button, Input, Space } from 'antd'
import classNames from 'classnames'
import { commonUtils } from '@/helpers/commonUtils'

type DiscountCodeInputProps = {
  discountCode: string
  handleDiscountCodeChange: (value: string) => void
  handleDiscountCodeClick: () => void
  rootClassName?: string
  statusInfo: {
    status: 'none' | 'success' | 'error'
    msg: string
  }
}

const DiscountCodeInput = observer((props: DiscountCodeInputProps) => {
  const {
    discountCode,
    handleDiscountCodeChange,
    handleDiscountCodeClick,
    rootClassName = '',
    statusInfo,
  } = props
  return (
    <div className={classNames(styles.discountCodeInput, rootClassName)}>
      <span className={classNames(styles.text)}>折扣券码:</span>
      <div className={styles.inputWrap}>
        <Input
          rootClassName={styles.inputBox}
          defaultValue=''
          value={discountCode}
          placeholder='请输入折扣券码'
          onChange={(e) => handleDiscountCodeChange(e.target.value)}
        />
        <button className={styles.btn} onClick={() => handleDiscountCodeClick()}>
          兑换
        </button>

        {statusInfo.status !== 'none' && (
          <div className={classNames(styles.statusMsg)}>
            <img
              className={classNames(styles.icon)}
              src={
                statusInfo.status === 'error'
                  ? commonUtils.getStaticFile('discount_err.png')
                  : commonUtils.getStaticFile('discount_ok.png')
              }
            />
            <span
              className={classNames(styles.msg, { [styles.error]: statusInfo.status === 'error' })}
            >
              {statusInfo.msg}
            </span>
          </div>
        )}
      </div>
    </div>
  )
})

export default DiscountCodeInput
